const UsageUnitEnum = Object.freeze({
  None: 'NONE',
  PerUnit: 'PerUnit',
  PerPack: 'PerPack',
});

export default UsageUnitEnum;
